import React, { useEffect, useState } from 'react';
import { Box, Dialog, Typography, styled } from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { autorun } from 'mobx';
import { observer } from 'mobx-react-lite';
import { Schaden } from '@codefluegel/wowis-rest-typescript-client';
import moment from 'moment';
import { useSchadenApi } from '../../ApiClient';

const StyledDescription = styled(Typography)({
  fontSize: 12,
  paddingTop: 12,
  fontWeight: 'light',
});

const ReportsInformationDialog = observer(
  ({
    open,
    onClose,
    customerId,
    objId,
    schadenId,
  }: {
    open: boolean;
    customerId: number;
    objId: number;
    schadenId: number;

    onClose: () => void;
  }): JSX.Element => {
    const damageApi = useSchadenApi();
    const [reportData, setReportData] = useState<Schaden>();

    useEffect(
      () =>
        autorun(() => {
          async function getDamageReports() {
            const { data } = await damageApi.getSchaden(
              objId,
              customerId,
              schadenId,
            );

            setReportData(data);
          }
          getDamageReports();
        }),
      [damageApi],
    );

    const handleClose = () => {
      onClose();
    };

    return (
      <Dialog onClose={handleClose} open={open} fullWidth maxWidth="sm">
        {reportData ? (
          <DialogContent>
            <Typography
              color="secondary"
              sx={{
                fontSize: 12,
                fontWeight: 'light',
                textTransform: 'uppercase',
                letterSpacing: 1.1,
              }}
            >
              Schaden
            </Typography>
            <DialogTitle variant="h4" sx={{ pl: 0, py: 1 }}>
              {reportData?.schad_art}
            </DialogTitle>
            <hr />
            <StyledDescription>Schadensgruppe</StyledDescription>
            <Typography variant="h6" color="secondary">
              {reportData?.schad_gruppe}
            </Typography>
            <StyledDescription>Feststellungsdatum</StyledDescription>
            <Typography variant="h6" color="secondary">
              {reportData?.schad_datum &&
                moment(reportData.schad_datum).format('DD.MM.YYYY')}
            </Typography>
            {reportData.schad_beschr && (
              <>
                <StyledDescription>Kurzbeschreibung </StyledDescription>
                <Typography variant="h6" color="secondary">
                  {reportData?.schad_beschr}
                </Typography>
              </>
            )}
            <StyledDescription>Status des Schadensfalles</StyledDescription>
            <Typography variant="h6" color="secondary">
              {reportData?.schad_status}
            </Typography>

            {(reportData.schad_melder ||
              reportData.schad_melder !== undefined) && (
              <>
                <StyledDescription>Melder des Schadensfalles</StyledDescription>
                <Typography variant="h6" color="secondary">
                  {reportData?.schad_melder}
                </Typography>
              </>
            )}
            {reportData.schad_bilder && (
              <>
                <br />
                {reportData.schad_bilder.length > 1 ? (
                  <StyledDescription>
                    Fotos des Schadensfalles
                  </StyledDescription>
                ) : (
                  <StyledDescription>Foto des Schadensfalles</StyledDescription>
                )}
                {reportData.schad_bilder?.map(image => (
                  <Box
                    key={image.dok_id}
                    sx={{ width: '100%', height: 'auto' }}
                  >
                    <img
                      src={`${process.env.REACT_APP_IMAGE_BASE_URL}/medium/${image.token}`}
                      alt=""
                      style={{
                        width: '100%',
                        height: 'auto',
                        objectFit: 'cover',
                      }}
                    />
                  </Box>
                ))}
              </>
            )}
            <br />
          </DialogContent>
        ) : (
          ''
        )}
        <DialogActions>
          <Button onClick={handleClose}>Abbrechen</Button>
        </DialogActions>
      </Dialog>
    );
  },
);

export default ReportsInformationDialog;
